import React from 'react'
import { Radio } from 'antd'
import styled from 'styled-components'

const DomainContainer = styled.div`
  margin-top: 16px;
  padding: 16px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`

const DomainTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 12px;
`

const DomainRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .ant-radio-wrapper {
    font-size: 14px;
    color: #475569;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.2s;

    &:hover {
      background-color: #f1f5f9;
    }
  }

  .ant-radio-wrapper-checked {
    background-color: #eef2ff;
    color: #444ce7;
    font-weight: 500;
  }
`

const DOMAIN_OPTIONS = [

  { value: 'BFSI', label: 'BFSI (Banking, Financial Services & Insurance)' },
  { value: 'Healthcare', label: 'Healthcare & Life Sciences' },
  { value: 'Technology', label: 'Technology & IT' },
  { value: 'Manufacturing', label: 'Manufacturing & Industrial' },
  { value: 'Retail', label: 'Retail & E-commerce' },
  { value: 'Consulting', label: 'Consulting & Professional Services' },
  

]

const DomainSelection = ({ value, onChange, error }) => {
  return (
    <DomainContainer style={error ? { border: '1px solid #ef4444' } : {}}>
      <DomainTitle>Select Domain *</DomainTitle>
      <DomainRadioGroup value={value} onChange={e => onChange(e.target.value)}>
        {DOMAIN_OPTIONS.map(option => (
          <Radio key={option.value} value={option.value}>
            {option.label}
          </Radio>
        ))}
      </DomainRadioGroup>
    </DomainContainer>
  )
}

export default DomainSelection